/* eslint-disable import/no-anonymous-default-export */

const EDrumPurchaseStatus = {
  PENDING: { code: 'PENDING', description: 'Não conferido', label: 'Não conferido', color: 'volcano' },
  CONFERRED: { code: 'CONFERRED', description: 'Conferido', label: 'Conferido', color: 'blue' },
};

EDrumPurchaseStatus.getByCode = (code) => Object.values(EDrumPurchaseStatus).find(t => t && t.code === code) || null;

export default EDrumPurchaseStatus;
